export class SubmitBenefAdvancedSearchReq {
  benef_index_no: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  sex: string;
  university_of_study: string;
  university_completion_year: number;
  university_start_year: number;
  phone_number: string;
  email: string;
}
